type TrustlyBankIconProps = {
  alpha2CountryCode?: string
  bankCode?: string
  bankName?: string
}

export const TrustlyBankIcon = ({ alpha2CountryCode, bankCode, bankName }: TrustlyBankIconProps) => {
  return alpha2CountryCode && bankCode ? (
    <img
      src={`https://content.trustly.com/logos/banks/${alpha2CountryCode}/${bankCode}/round.svg`}
      title={bankName}
      alt='Bank logo'
    />
  ) : null
}
